/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

// Comprehensive form options for job and internship posting

export const countries = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria",
  "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan",
  "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia",
  "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica",
  "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt",
  "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon",
  "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
  "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
  "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan",
  "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar",
  "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia",
  "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal",
  "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan",
  "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar",
  "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia",
  "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa",
  "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan",
  "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan",
  "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City",
  "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];

export const currencies = [
  // Major Global Currencies
  { code: "USD", name: "US Dollar", symbol: "$" },
  { code: "EUR", name: "Euro", symbol: "€" },
  { code: "GBP", name: "British Pound", symbol: "£" },
  { code: "JPY", name: "Japanese Yen", symbol: "¥" },
  { code: "CHF", name: "Swiss Franc", symbol: "CHF" },
  
  // North America
  { code: "CAD", name: "Canadian Dollar", symbol: "C$" },
  { code: "MXN", name: "Mexican Peso", symbol: "$" },
  
  // South America
  { code: "BRL", name: "Brazilian Real", symbol: "R$" },
  { code: "ARS", name: "Argentine Peso", symbol: "$" },
  { code: "CLP", name: "Chilean Peso", symbol: "$" },
  { code: "COP", name: "Colombian Peso", symbol: "$" },
  { code: "PEN", name: "Peruvian Sol", symbol: "S/" },
  { code: "UYU", name: "Uruguayan Peso", symbol: "$U" },
  { code: "VES", name: "Venezuelan Bolívar", symbol: "Bs." },
  
  // Asia Pacific
  { code: "CNY", name: "Chinese Yuan", symbol: "¥" },
  { code: "INR", name: "Indian Rupee", symbol: "₹" },
  { code: "KRW", name: "South Korean Won", symbol: "₩" },
  { code: "SGD", name: "Singapore Dollar", symbol: "S$" },
  { code: "HKD", name: "Hong Kong Dollar", symbol: "HK$" },
  { code: "TWD", name: "Taiwan Dollar", symbol: "NT$" },
  { code: "THB", name: "Thai Baht", symbol: "฿" },
  { code: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
  { code: "IDR", name: "Indonesian Rupiah", symbol: "Rp" },
  { code: "PHP", name: "Philippine Peso", symbol: "₱" },
  { code: "VND", name: "Vietnamese Dong", symbol: "₫" },
  { code: "PKR", name: "Pakistani Rupee", symbol: "₨" },
  { code: "BDT", name: "Bangladeshi Taka", symbol: "৳" },
  { code: "LKR", name: "Sri Lankan Rupee", symbol: "Rs" },
  { code: "NPR", name: "Nepalese Rupee", symbol: "Rs" },
  { code: "AUD", name: "Australian Dollar", symbol: "A$" },
  { code: "NZD", name: "New Zealand Dollar", symbol: "NZ$" },
  
  // Middle East
  { code: "AED", name: "UAE Dirham", symbol: "د.إ" },
  { code: "SAR", name: "Saudi Riyal", symbol: "﷼" },
  { code: "QAR", name: "Qatari Riyal", symbol: "ر.ق" },
  { code: "KWD", name: "Kuwaiti Dinar", symbol: "د.ك" },
  { code: "BHD", name: "Bahraini Dinar", symbol: "د.ب" },
  { code: "OMR", name: "Omani Rial", symbol: "ر.ع." },
  { code: "JOD", name: "Jordanian Dinar", symbol: "د.ا" },
  { code: "ILS", name: "Israeli Shekel", symbol: "₪" },
  { code: "TRY", name: "Turkish Lira", symbol: "₺" },
  { code: "IRR", name: "Iranian Rial", symbol: "﷼" },
  
  // Africa
  { code: "ZAR", name: "South African Rand", symbol: "R" },
  { code: "NGN", name: "Nigerian Naira", symbol: "₦" },
  { code: "KES", name: "Kenyan Shilling", symbol: "KSh" },
  { code: "EGP", name: "Egyptian Pound", symbol: "£" },
  { code: "GHS", name: "Ghanaian Cedi", symbol: "₵" },
  { code: "TZS", name: "Tanzanian Shilling", symbol: "TSh" },
  { code: "UGX", name: "Ugandan Shilling", symbol: "USh" },
  { code: "MAD", name: "Moroccan Dirham", symbol: "د.م." },
  { code: "ETB", name: "Ethiopian Birr", symbol: "Br" },
  { code: "XOF", name: "West African CFA Franc", symbol: "Fr" },
  { code: "XAF", name: "Central African CFA Franc", symbol: "Fr" },
  
  // Europe
  { code: "SEK", name: "Swedish Krona", symbol: "kr" },
  { code: "NOK", name: "Norwegian Krone", symbol: "kr" },
  { code: "DKK", name: "Danish Krone", symbol: "kr" },
  { code: "PLN", name: "Polish Zloty", symbol: "zł" },
  { code: "CZK", name: "Czech Koruna", symbol: "Kč" },
  { code: "HUF", name: "Hungarian Forint", symbol: "Ft" },
  { code: "RON", name: "Romanian Leu", symbol: "lei" },
  { code: "BGN", name: "Bulgarian Lev", symbol: "лв" },
  { code: "HRK", name: "Croatian Kuna", symbol: "kn" },
  { code: "RSD", name: "Serbian Dinar", symbol: "дин" },
  { code: "UAH", name: "Ukrainian Hryvnia", symbol: "₴" },
  { code: "RUB", name: "Russian Ruble", symbol: "₽" },
  { code: "BYN", name: "Belarusian Ruble", symbol: "Br" },
  { code: "ISK", name: "Icelandic Króna", symbol: "kr" },
  
  // Other Regions
  { code: "FJD", name: "Fijian Dollar", symbol: "$" },
  { code: "PGK", name: "Papua New Guinean Kina", symbol: "K" }
];

export const industries = [
  "Accounting", "Advertising", "Aerospace & Defense", "Agriculture", "Airlines/Aviation", "Alternative Dispute Resolution",
  "Alternative Medicine", "Animation", "Apparel & Fashion", "Architecture & Planning", "Arts & Crafts", "Automotive",
  "Aviation & Aerospace", "Banking", "Biotechnology", "Broadcast Media", "Building Materials", "Business Supplies & Equipment",
  "Capital Markets", "Chemicals", "Civic & Social Organization", "Civil Engineering", "Commercial Real Estate", "Computer & Network Security",
  "Computer Games", "Computer Hardware", "Computer Networking", "Computer Software", "Construction", "Consumer Electronics",
  "Consumer Goods", "Consumer Services", "Cosmetics", "Dairy", "Defense & Space", "Design", "E-Learning",
  "Education Management", "Electrical/Electronic Manufacturing", "Entertainment", "Environmental Services", "Events Services",
  "Executive Office", "Facilities Services", "Farming", "Financial Services", "Fine Art", "Fishery", "Food & Beverages",
  "Food Production", "Fundraising", "Furniture", "Gambling & Casinos", "Glass, Ceramics & Concrete", "Government Administration",
  "Government Relations", "Graphic Design", "Health, Wellness & Fitness", "Higher Education", "Hospital & Health Care",
  "Hospitality", "Human Resources", "Import & Export", "Individual & Family Services", "Industrial Automation", "Information Services",
  "Information Technology & Services", "Insurance", "International Affairs", "International Trade & Development", "Internet",
  "Investment Banking", "Investment Management", "Judiciary", "Law Enforcement", "Law Practice", "Legal Services",
  "Legislative Office", "Leisure, Travel & Tourism", "Libraries", "Logistics & Supply Chain", "Luxury Goods & Jewelry",
  "Machinery", "Management Consulting", "Maritime", "Market Research", "Marketing & Advertising", "Mechanical or Industrial Engineering",
  "Media Production", "Medical Devices", "Medical Practice", "Mental Health Care", "Military", "Mining & Metals",
  "Motion Pictures & Film", "Museums & Institutions", "Music", "Nanotechnology", "Newspapers", "Non-Profit Organization Management",
  "Oil & Energy", "Online Media", "Outsourcing/Offshoring", "Package/Freight Delivery", "Packaging & Containers", "Paper & Forest Products",
  "Performing Arts", "Pharmaceuticals", "Philanthropy", "Photography", "Plastics", "Political Organization", "Primary/Secondary Education",
  "Printing", "Professional Training & Coaching", "Program Development", "Public Policy", "Public Relations & Communications",
  "Public Safety", "Publishing", "Railroad Manufacture", "Ranching", "Real Estate", "Recreational Facilities & Services",
  "Religious Institutions", "Renewables & Environment", "Research", "Restaurants", "Retail", "Security & Investigations",
  "Semiconductors", "Shipbuilding", "Sporting Goods", "Sports", "Staffing & Recruiting", "Supermarkets", "Telecommunications",
  "Textiles", "Think Tanks", "Tobacco", "Translation & Localization", "Transportation/Trucking/Railroad", "Utilities",
  "Venture Capital & Private Equity", "Veterinary", "Warehousing", "Wholesale", "Wine & Spirits", "Wireless", "Writing & Editing"
];

export const departments = [
  "Accounting & Finance", "Administrative", "Analytics", "Art/Creative", "Business Development", "Community & Social Services",
  "Consulting", "Customer Service", "Design", "Distribution & Logistics", "Education", "Engineering",
  "Entrepreneurship", "Finance", "Healthcare Services", "Human Resources", "Information Technology", "Legal",
  "Management", "Manufacturing", "Marketing", "Media & Communication", "Military & Protective Services", "Operations",
  "Product Management", "Program & Project Management", "Purchasing", "Quality Assurance", "Real Estate", "Research",
  "Sales", "Science", "Security Guard", "Strategy/Planning", "Supply Chain", "Support"
];

// Comprehensive Global Skills List
export const allSkills = [
  "3D Modeling", "A/B Testing", "Accounting Principles", "Accounting Software", "Acoustics", "Active Listening", 
  "Adaptability", "Adobe Creative Suite", "Adult Learning Theory", "Agile/Scrum", "Agricultural Practices", 
  "Aircraft Operation", "Algorithms", "Analysis", "Anatomy Knowledge", "Animal Medicine", "API Development", 
  "Architectural Design", "Artificial Intelligence", "Assessment", "Assessment Design", "ATS Software", 
  "Attention to Detail", "Audio Editing", "Audio Equipment", "Audio Mixing", "Auditing", "AutoCAD", 
  "Aviation Regulations", "AWS/Azure/GCP", "Backup/Recovery", "Banking Regulations", "Benefits Administration", 
  "Big Data", "Bioinformatics", "Biotechnology", "Blockchain", "Blueprint Reading", "Bookkeeping", 
  "Brand Guidelines", "Brand Management", "Brand Strategy", "Brand Voice", "Budget Management", "Budgeting", 
  "Building Codes", "Building Systems", "CAD Software", "Call Center Metrics", "Campaign Management", 
  "Campaign Planning", "Candidate Assessment", "Capital Markets", "Care Planning", "Career Counseling", 
  "Case Analysis", "Case Management", "Cash Handling", "Change Management", "Chemical Analysis", 
  "Circuit Analysis", "Circuit Design", "Classroom Management", "Client Counseling", "Client Communication", 
  "Client Relations", "Clinical Knowledge", "Closing", "Cloud Computing", "CMS Platforms", "Color Correction", 
  "Color Theory", "Communication", "Communication Strategy", "Community Engagement", "Community Management", 
  "Community Relations", "Compassion", "Compensation Analysis", "Compliance", "Computer Skills", "Confidentiality", 
  "Conflict Resolution", "Construction Knowledge", "Construction Materials", "Construction Methods", 
  "Content Creation", "Content Marketing", "Content Strategy", "Continuous Learning", "Contract Knowledge", 
  "Contract Management", "Contract Negotiation", "Cooking Techniques", "Copywriting", "Cost Analysis", 
  "Cost Control", "Cost Estimation", "Cost Management", "Counseling", "Creativity", "Credit Analysis", 
  "Crisis Intervention", "Crisis Management", "Critical Thinking", "CRM Software", "Crop Management", 
  "Crop Science", "Cryptography", "Cultural Competence", "Cultural Sensitivity", "Curriculum Design", 
  "Curriculum Development", "Customer Service", "Cybersecurity Awareness", "Data Analysis", "Data Collection", 
  "Data Interpretation", "Data Science", "Data Security", "Data Structures", "Data Visualization", 
  "Database Design", "Database Management", "Deadline Management", "Deadlines", "Debugging", "Decision Making", 
  "Design Systems", "Design Thinking", "Diagnosis", "Digital Literacy", "Digital Marketing", "Digital Media", 
  "Display Design", "Docker", "Documentation", "Document Preparation", "DOT Regulations", "Donor Relations", 
  "E-learning", "E-learning Development", "Economics", "Editing", "Education Law", "Efficiency Standards", 
  "Electrical Codes", "Electrical Installation", "Electrical Systems", "Email Marketing", "Emergency Procedures", 
  "Emergency Response", "Emotional Intelligence", "Empathy", "Employee Relations", "Energy Analysis", 
  "Engineering Design", "Environmental Assessment", "Equipment Design", "Equipment Operation", "Equipment Repair", 
  "ERP Systems", "Ethics", "Ethical Hacking", "Evaluation", "Event Coordination", "Event Planning", "Excel", 
  "Experimentation", "Facilitation", "Fact Checking", "FEA", "Field Testing", "Field Work", "Figma/Sketch", 
  "File Management", "Filing", "Financial Analysis", "Financial Modeling", "Financial Reporting", 
  "Financial Statement Analysis", "First Aid", "Food Safety", "Forecasting", "Fundraising Strategy", 
  "GAAP/IFRS", "GIS", "Git", "Google Analytics", "Government Processes", "GPS Navigation", "Grammar", 
  "Grant Writing", "Graphic Design", "Hand/Power Tools", "Healthcare Management", "Healthcare Regulations", 
  "HRIS", "HTML/CSS", "Incident Response", "Industry Research", "Infrastructure as Code", "Innovation", 
  "Inspection", "Instrumentation", "Internet of Things (IoT)", "Interpersonal Skills", "Interviewing", 
  "Inventory Management", "Inventory Optimization", "Investigation", "Investment Analysis", "Irrigation Systems", 
  "ISO Standards", "Java", "Kitchen Management", "Kubernetes", "Lab Equipment Operation", "Labor Law", 
  "Laboratory Testing", "Laboratory Techniques", "Language Skills", "Layout Design", "Leadership", 
  "Lean Manufacturing", "Learning Management Systems", "Lease Management", "Leasing", "Legal Knowledge", 
  "Legal Research", "Legal Software", "Legal Terminology", "Legal Writing", "Lesson Planning", "Linux", 
  "Listening", "Literature Review", "Litigation", "Livestock Management", "Local Knowledge", "Lodash", 
  "Logistics", "M&A Analysis", "Machine Learning", "Maintenance", "Manual Dexterity", "Manual Therapy", 
  "Manufacturing Processes", "Market Analysis", "Market Knowledge", "Market Research", "Marketing", 
  "Marketing Automation", "Marketing Strategy", "Materials Science", "Mathematics", "Mechanical Design", 
  "Mechanical Systems", "Media Relations", "Medical Diagnosis", "Medical Equipment", "Medical Ethics", 
  "Medication Administration", "Menu Planning", "Merchandise Display", "Microscopy", "Molecular Biology", 
  "Monitoring", "Motion Graphics", "Multitasking", "Music Theory", "MySQL/PostgreSQL/MongoDB", "Navigation", 
  "Needs Analysis", "Negotiation", "Network Security", "Networking", "News Judgment", "Office Software", 
  "Operations Management", "Operations Research", "Organization", "Pain Management", "Papaparse", 
  "Patient Assessment", "Patient Care", "Patient Evaluation", "Patience", "Penetration Testing", 
  "Performance Management", "Performance Tuning", "Pest Management", "Phone Etiquette", "Photography", 
  "Physical Stamina", "Planning", "Policy Development", "Policy Research", "POS Systems", "Power Systems", 
  "PowerPoint", "Presentation", "Preventive Maintenance", "Print Production", "Problem Solving", 
  "Process Improvement", "Process Optimization", "Product Knowledge", "Production Planning", "Program Knowledge", 
  "Program Management", "Programming (Python, Java, C++)", "Project Management", "Project Planning", 
  "Property Maintenance", "Property Valuation", "Prospecting", "Prototyping", "Public Speaking", "Python", 
  "Quality Assurance", "Quality Control", "Quality Standards", "Quantum Computing", "R", "Record Keeping", 
  "Recruitment", "Regulations", "Regulatory Compliance", "Regulatory Knowledge", "Rehabilitation", 
  "Relationship Building", "Remote Collaboration", "Remote Support Tools", "Renewable Energy", "Replication", 
  "Report Writing", "Reporting", "Research", "Research Methodology", "Reservation Systems", "Resource Coordination", 
  "Retail Operations", "Retail Trends", "Revenue Management", "Risk Assessment", "Risk Management", 
  "Risk Modeling", "Root Cause Analysis", "Route Planning", "Safe Driving", "Safety Awareness", 
  "Safety Management", "Safety Procedures", "Safety Protocols", "Safety Regulations", "Safety Standards", 
  "Sales", "Scheduling", "Scheduling Tools", "Scientific Writing", "Scripting", "Security", "Security Frameworks", 
  "SEM", "SEO", "SheetJS", "SIEM Tools", "Simulation", "Site Analysis", "Site Supervision", "Six Sigma", 
  "Social Media", "Social Media Marketing", "Social Media Strategy", "Software Design", "Software Systems", 
  "Soil Analysis", "Soil Science", "Sound Recording", "Sourcing", "Space Planning", "Specimen Collection", 
  "SQL", "Staff Management", "Staff Supervision", "Stakeholder Engagement", "Stakeholder Management", 
  "Stakeholder Relations", "Statistical Analysis", "Statistical Process Control", "Statistics", "Storytelling", 
  "Strategic Planning", "Stress Management", "Structural Design", "Student Advising", "Student Engagement", 
  "Subject Expertise", "Supply Chain", "Supply Chain Management", "Supply Chain Strategy", "Surgery", 
  "Sustainability", "Sustainability Practices", "Tax Preparation", "Teamwork", "Technical Documentation", 
  "Technical Drawing", "Technical Knowledge", "Technical Support", "Technical Troubleshooting", "Technical Writing", 
  "Technology Integration", "Tenant Relations", "TensorFlow/PyTorch", "Testing", "Testing Methods", 
  "Thermodynamics", "Threat Analysis", "Time Management", "Training", "Training Design", "Transcription", 
  "Transportation Planning", "Treatment Planning", "Trend Awareness", "Trend Forecasting", "Troubleshooting", 
  "Typography", "Urban Design", "User Research", "User Testing", "Valuation", "Vehicle Maintenance", 
  "Vendor Management", "Vendor Relations", "Video Editing Software", "Visual Design", "Visual Merchandising", 
  "Vital Signs Monitoring", "Volunteer Management", "Warehouse Operations", "Weather Analysis", 
  "Weather Monitoring", "Web Design", "Wireframing", "Wiring", "WMS Software", "Work Ethic", "Writing", "Zoning"
];

// Software & Tools - for jobseeker profile dropdown
export const softwareAndTools = [
  "Adobe Creative Suite", "Adobe Illustrator", "Adobe Photoshop", "Adobe InDesign", "Asana",
  "AutoCAD", "AWS/Azure/GCP", "Azure DevOps", "CAD Software", "CRM Software", "Docker",
  "ERP Systems", "Figma", "Figma/Sketch", "Git", "Google Analytics", "Google Workspace",
  "Jira", "Kubernetes", "Microsoft Excel", "Microsoft Office", "Microsoft PowerPoint",
  "Microsoft Teams", "Microsoft Word", "MySQL/PostgreSQL/MongoDB", "QuickBooks",
  "Salesforce", "SAP", "Sketch", "Slack", "SQL", "Trello", "Video Editing Software",
  "Zoom", "ATS Software", "HRIS", "Learning Management Systems", "POS Systems",
  "Legal Software", "WMS Software", "Remote Support Tools", "Scheduling Tools"
].sort();

const extraProgrammingAndTech = [
  "Python", "Java", "JavaScript", "TypeScript", "C++", "C#", "SQL", "HTML/CSS", "R", "MATLAB", "PHP", "Ruby", "Swift", "Kotlin", "Go", "Rust", "Scala", "Perl", "Dart",
  "Shell Scripting", "PowerShell", "VBA", "React", "Angular", "Vue.js", "Node.js", "Express.js", "Next.js",
  "MySQL", "PostgreSQL", "MongoDB", "Redis", "Docker", "Kubernetes", "Terraform", "Ansible", "Jenkins",
  "AWS", "Azure", "GCP", "Git", "GitHub", "GitLab", "Linux", "Unix", "Machine Learning", "Data Science",
  "Deep Learning", "NLP", "Computer Vision", "DevOps", "CI/CD", "REST APIs", "GraphQL", "TensorFlow", "PyTorch", "pandas", "NumPy", "SciPy", "Tableau", "Power BI", "Snowflake", "Databricks"
];

/** Suggestions for intern registration technical skills (languages, software, tools) */
export const technicalSkillsSuggestions = [...new Set([...softwareAndTools, ...extraProgrammingAndTech])].sort((a, b) => a.localeCompare(b));

/** Suggestions for intern registration soft / interpersonal skills */
export const softSkillsSuggestions = [
  "Accountability", "Active Listening", "Adaptability", "Analytical Thinking", "Attention to Detail",
  "Building Rapport", "Coaching", "Collaboration", "Communication", "Compassion",
  "Conflict Resolution", "Creativity", "Critical Thinking", "Cultural Awareness", "Cultural Sensitivity",
  "Curiosity", "Customer Service", "Decision Making", "Delegation", "Emotional Intelligence",
  "Empathy", "Facilitation", "Flexibility", "Giving Feedback", "Growth Mindset",
  "Honesty", "Humility", "Influence", "Initiative", "Integrity",
  "Interpersonal Skills", "Leadership", "Listening", "Mediation", "Mentoring",
  "Multitasking", "Negotiation", "Networking", "Open-mindedness", "Organization",
  "Patience", "Persuasion", "Positive Attitude", "Presentation Skills", "Problem Solving",
  "Public Speaking", "Receiving Feedback", "Relationship Building", "Resilience", "Resourcefulness",
  "Self-Motivation", "Stakeholder Engagement", "Stakeholder Management", "Storytelling", "Strategic Thinking",
  "Stress Management", "Teamwork", "Time Management", "Trust Building", "Volunteer Coordination",
  "Work Ethic", "Writing"
].sort((a, b) => a.localeCompare(b));

export const jobTypes = ["Full-time", "Part-time", "Contract", "Freelance", "Temporary", "Internship"];

export const workModes = ["On-site", "Hybrid", "Remote"];

export const experienceLevels = [
  "Entry Level (0-1 years)",
  "Mid Level (2-5 years)",
  "Senior Level (5-10 years)",
  "Lead/Manager (8+ years)",
  "Director (10+ years)",
  "Executive/C-Level (15+ years)"
];

export const educationLevels = [
  "Any",
  "High School Diploma",
  "Diploma/Certificate",
  "Associate Degree",
  "Bachelor's Degree",
  "Master's Degree",
  "MBA",
  "PhD/Doctorate",
  "Professional Certification"
];

export const benefits = [
  "Health Insurance", "Dental Insurance", "Vision Insurance", "Life Insurance",
  "Disability Insurance", "Retirement Plan (401k)", "Pension Plan",
  "Performance Bonus", "Annual Bonus", "Stock Options", "Profit Sharing",
  "Paid Time Off (PTO)", "Vacation Days", "Sick Leave", "Parental Leave",
  "Maternity Leave", "Paternity Leave", "Sabbatical", "Mental Health Days",
  "Flexible Work Hours", "Remote Work Options", "Work From Home",
  "Relocation Assistance", "Housing Allowance", "Transportation Allowance",
  "Gym Membership", "Wellness Programs", "Employee Assistance Program (EAP)",
  "Professional Development", "Training Budget", "Conference Attendance",
  "Tuition Reimbursement", "Certification Programs", "Mentorship Programs",
  "Free Meals", "Snacks & Beverages", "Team Lunches", "Company Events",
  "Childcare Assistance", "Elder Care Assistance", "Pet Insurance",
  "Employee Discounts", "Company Car", "Laptop/Equipment", "Phone Allowance",
  "Internet Reimbursement", "Coworking Space Access"
];

export const internshipDurations = [
  "1 Month",
  "2 Months",
  "3 Months",
  "4 Months",
  "5 Months",
  "6 Months",
  "6+ Months",
  "Flexible"
];

export const stipendTypes = ["Paid", "Unpaid", "Performance-based", "Commission-based"];

export const workingDaysPerWeek = ["3 days", "4 days", "5 days", "6 days", "Flexible"];

export const salaryTypes = [
  "Fixed",
  "Negotiable",
  "Commission-based",
  "Hourly",
  "Monthly",
  "Weekly",
  "Performance-based"
];

export const salaryPeriods = [
  { value: "yearly", label: "Per Year" },
  { value: "monthly", label: "Per Month" },
  { value: "weekly", label: "Per Week" }
];

export const applyMethods = [
  "Apply through platform",
  "Send email",
  "External website/link",
  "In-person application"
];

export const visibilityOptions = [
  { value: "public", label: "Public - Visible to all job seekers" },
  { value: "private", label: "Private - Only visible to invited candidates" }
];

